var _circle, _path, _g, _g2, _g3, _circle2, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 11,
    fill: "url(#paint0_linear_3334_32881)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1C7.92487 1 3 5.92487 3 12H25C25 5.92487 20.0751 1 14 1Z",
    fill: "url(#paint1_linear_3334_32881)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3334_32881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9L5 8M19 9L23 8",
    stroke: "#A9B6C9",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3334_32881)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91705 12.4932C6.71308 13.0793 6.15567 13.5 5.5 13.5C4.84689 13.5 4.29127 13.0826 4.08535 12.5H3C2.72386 12.5 2.5 12.2761 2.5 12C2.5 11.7239 2.72386 11.5 3 11.5H4.08535C4.29127 10.9174 4.84689 10.5 5.5 10.5C6.15567 10.5 6.71308 10.9207 6.91705 11.5068C6.94403 11.5023 6.97174 11.5 7 11.5H10C10.2761 11.5 10.5 11.7239 10.5 12C10.5 12.2761 10.2761 12.5 10 12.5H7C6.97174 12.5 6.94403 12.4977 6.91705 12.4932ZM22.5 13.5C23.1531 13.5 23.7087 13.0826 23.9146 12.5H25C25.2761 12.5 25.5 12.2761 25.5 12C25.5 11.7239 25.2761 11.5 25 11.5H23.9146C23.7087 10.9174 23.1531 10.5 22.5 10.5C21.8469 10.5 21.2913 10.9174 21.0854 11.5H19C18.7239 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.7239 12.5 19 12.5H21.0854C21.2913 13.0826 21.8469 13.5 22.5 13.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3334_32881)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 6,
    fill: "#5EB5E9"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 4.5,
    fill: "url(#paint2_radial_3334_32881)",
    stroke: "#19496F"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3334_32881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0974 10.7546C16.8425 11.1917 15.8623 11.0949 14.9082 10.5383C13.9541 9.98176 13.3873 9.17626 13.6423 8.73917C13.8972 8.30207 14.8774 8.39891 15.8315 8.95546C16.7856 9.51201 17.3524 10.3175 17.0974 10.7546Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3334_32881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0055 5.4295C20.7127 5.9313 19.3494 5.68122 17.9603 4.87094C16.5712 4.06066 15.6824 2.99701 15.9751 2.49521C16.2678 1.99342 17.6109 2.18972 19 3C20.3891 3.81028 21.2982 4.9277 21.0055 5.4295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3334_32881",
    x: 3.5,
    y: 6.5,
    width: 21,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3334_32881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3334_32881",
    x: 0.5,
    y: 9.5,
    width: 27,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3334_32881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3334_32881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3334_32881",
    x: 6,
    y: 5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3334_32881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3334_32881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3334_32881",
    x: 12.5811,
    y: 7.46558,
    width: 5.57764,
    height: 4.56274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3334_32881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3334_32881",
    x: 14.9194,
    y: 1.2207,
    width: 7.14062,
    height: 5.46753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3334_32881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3334_32881",
    x1: 14,
    y1: 1,
    x2: 14,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.584912,
    stopColor: "#4B55EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3233C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3334_32881",
    x1: 14,
    y1: 1,
    x2: 14,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5393FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51A4F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3334_32881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 12) rotate(90) scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#76C8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D8F0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.4b9d68566510e07b3f36d33d38b87444.svg";
export { ForwardRef as ReactComponent };